module.exports = __webpack_public_path__ + "static/media/12-surtugdrdrg.9d07e309.png";